import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=37aac13e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=37aac13e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aac13e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37aac13e')) {
      api.createRecord('37aac13e', component.options)
    } else {
      api.reload('37aac13e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=37aac13e&scoped=true&", function () {
      api.rerender('37aac13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/reports/response-time/Index.vue"
export default component.exports